<template>
  <div>
    <div class="top">
      <div class="logo">
        <img src="@/assets/png/home/zqw.png" alt="" />
      </div>
      <div class="tab">
        <div class="box" @click="toHome()">首页</div>
        <div class="box" @click="toHundred()">编委会</div>
        <!-- <div class="box acitves" @click="toAncestors()">寻亲问祖</div> -->
        <div class="box" @click="toGenealogy()">家谱库</div>
        <!-- <div class="box" @click="toPartyBuilding()">党建学习</div> -->
        <div class="box" @click="toDownload()">下载中心</div>
        <div class="box" @click="toAbout()">关于我们</div>
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/png/home/banner.png" alt="" />
    </div>
    <div class="content">
      <div class="content-con">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div class="con">
        <div class="top1">
          <img src="@/assets/png/home/smallLogo.png" alt="" />
          <p>寻亲问祖</p>
          <div class="xian2"></div>
        </div>

        <div class="con1">
          <div
            class="cards"
            v-for="(item, index) in slicedArrayList"
            :key="index"
            style="cursor: pointer; z-index: 99999"
            @click="relativesClick(item)"
          >
            <img src="@/assets/png/home/relatives.png" alt="" />
            <div class="co">
              <div class="a">
                <div style="display: flex">
                  <p>姓名:&nbsp;&nbsp;</p>
                  <p>{{ item.name }}</p>
                </div>
                <div class="d">
                  <div class="item"></div>
                  <p>寻亲时间:&nbsp;&nbsp;</p>
                  <p>{{ item.createTime }}</p>
                </div>
              </div>
              <div class="a b">
                <p>字辈:&nbsp;&nbsp; {{ item.generationPoetry }}</p>
              </div>
              <div class="a c">
                <p>手机:&nbsp;&nbsp; {{ item.phone }}</p>
                <p>祖籍:&nbsp;&nbsp; {{ item.areaName }}</p>
              </div>
              <div class="le"></div>
              <div class="ri"></div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            style="z-index: 999"
            class="custom-pagination"
            @current-change="handleSizeChange"
          >
          </el-pagination>

          <!-- <div class="box2">首页</div>
          <div class="box2">上一页</div>
          <div class="box2">1</div>
          <div class="box2">下一页</div>
          <div class="box2">尾页</div> -->
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="e">
        <div class="left2">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="right2">
          <p>版权所有:&nbsp;&nbsp;安徽图腾传承文化有限公司</p>
          <div style="display: flex">
            <p>客服电话:&nbsp;&nbsp;18963782919</p>
            <p style="margin-left: 20px">
              企业邮箱:&nbsp;&nbsp;zhzqwvip@163.com
            </p>
          </div>
          <div style="display: flex">
            <p>备案号:&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">皖ICP备1833721395-1号</a></p>
            <p style="margin-left: 20px">
              公安备案:&nbsp;&nbsp;皖公网安备 34019202000232号
            </p>
            <!-- <p style="margin-left: 20px">编委会管理中心</p> -->
            <a
              href="https://client.zqyp.net/"
              target="_blank"
              style="margin-left: 20px"
              >编委会管理中心</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slicedArrayList: [],
      currentPage: 1,
      pageSize: 8,
      // 总数
      total: 0,
    };
  },
  created() {
    // 百家姓
    this.getSlicedArray();
    //     // 寻亲问祖
    //     this.getMenus();
    // this.activePath = localStorage.getItem('path')
  },
  methods: {
    relativesClick(item) {
      this.$router.push({
        path: "./noticelist",
        query: {
          item: item,
        },
      });
    },
    // 切换分页
    handleSizeChange(val) {
      this.currentPage = val;
      // 百家姓
      this.getSlicedArray();

      console.log(val, "val");
    },

    async getSlicedArray() {
      // const { data: res } = await this.instance1.post("seekRoot/getList?portTypeCode=PC_LMFW_XQWZ", {
      //   currentPage: this.currentPage,
      //   pageSize: this.pageSize,
      // });
      // this.slicedArrayList = res.data.list;
      // console.log(res.data.total, "res.data.total");
      // this.total = res.data.total;
      //   this.slicedArrayList=
    },

    // 首页
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
    // 百家姓
    toHundred() {
      this.$router.push({
        path: "./surnameList",
      });
    },
    // 寻亲问祖
    toAncestors() {
      // this.$router.push({
      //   path: "./ancestors",
      // });
    },
    // 家谱库
    toGenealogy() {
      this.$router.push({
        path: "./genealogy",
      });
      // location.href = "./genealogy.html";
    },

    // 党建学习
    toPartyBuilding() {
      this.$router.push({
        path: "./partyBuilding",
      });
    },

    // 下载中心
    toDownload() {
      this.$router.push({
        path: "./download",
      });
      // location.href = "./download.html";
    },
    // 关于我们
    toAbout() {
      this.$router.push({
        path: "./about",
      });
    },
  },
};
</script>

<style scoped>
::v-deep .custom-pagination .el-pager .active {
  /* 设置自定义的页码背景颜色 */
  background-color: #bf1b28 !important;
}

::v-deep .custom-pagination .el-pager li:hover {
  color: #bf1b28 !important;
}

::v-deep .custom-pagination .el-pager .active:hover {
  /* 设置自定义的页码背景颜色 */
  color: #fff !important;
}

.con1 {
  width: 100%;
  /* height: 1000px; */

  display: flex;
  flex-wrap: wrap;
}

.cards {
  width: 45%;
  margin-bottom: 50px;
  position: relative;
  height: 180px;
  font-size: 18px;
  font-weight: normal;
  margin-right: 50px;
  color: #616161;
}

.cards img {
  width: 100%;
  height: 8px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 22;
}

.co {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(@/assets/png/home/rectangle.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.ri {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/png/home/background.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0px 0px;
}

.a {
  width: 100%;
  height: 20%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  padding-left: 14px;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
}

.b {
  margin-top: 10px;
  padding-right: 40px;
}

.c {
  margin-top: 10px;
  padding-right: 40px;
}

.d {
  width: 211px;
  height: 21px;
  background-image: url(@/assets/png/home/5.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 22;
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #fff;
}

.item {
  width: 14px;
  height: 14px;
  background-image: url(@/assets/png/home/time.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.bottom {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box2 {
  padding: 10px;
  border: 1px solid #c2c2c2;
}

* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #f8f8f8;
}

.top {
  width: 100%;
  height: 145px;
  background: url(@/assets/png/home/top.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.active {
  border-bottom: 2px solid #bf1c29;
}

.top .logo {
  width: 170px;
  height: 73px;
}

.logo > img {
  width: 100%;
  height: 100%;
}

.top .tab {
  width: 38%;
  display: flex;
  justify-content: space-between;
}

.top .tab .box {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  cursor: pointer;
  height: 35px;
}

.acitves {
  border-bottom: 2px solid #cd4f4b;
}

.banner {
  width: 100%;
  height: 400px;
}

.banner img {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: calc(1996px - 645px - 161px);
  position: relative;
}

.content .content-con {
  position: absolute;
  left: 16%;
  width: 67%;
  height: calc(1996px - 645px - 161px);
  display: flex;
}

.content .content-con .left {
  width: 50%;
  height: calc(1996px - 645px - 161px - 280px);
  background: url(@/assets/png/home/left.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 50px;
  margin-bottom: 230px;
  z-index: 22;
}

.content .content-con .right {
  width: 50%;
  height: calc(1996px - 645px - 161px - 280px);
  background: url(@/assets/png/home/right.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 280px;
  z-index: 22;
}

.con {
  width: 67%;
  height: calc(1996px - 645px - 161px);

  margin: 0 auto;
  padding-top: 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.top1 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  justify-content: space-between;
  position: relative;
}

.xian2 {
  width: 88%;
  height: 1px;
  background-color: #dddddd;
}

.more {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #c2c2c2;
}

.e {
  width: 62%;
  height: 100%;
  display: flex;
  align-items: center;
}

.left2 {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right2 {
  width: 85%;
  height: 60%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.foot {
  width: 100%;
  height: 161px;
  background-image: url(@/assets/png/home/bottom.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-left: 20%;
  box-sizing: border-box;
}
</style>
